/* V6: menu open/close + ledger peek */
(function(){
  var burger = document.getElementById('burger');
  var overlay = document.getElementById('menuOverlay');
  var closer = document.getElementById('menuClose');
  function setOpen(open){
    overlay.classList.toggle('open', open);
    burger.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger && overlay){
    burger.addEventListener('click', function(){ setOpen(!overlay.classList.contains('open')); });
    if (closer) closer.addEventListener('click', function(){ setOpen(false); });
    overlay.querySelectorAll('nav a').forEach(function(a){
      a.addEventListener('click', function(){ setOpen(false); });
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') setOpen(false); });
  }
  document.querySelectorAll('.ledger .row').forEach(function(row){
    var peek = row.querySelector('.peek');
    if (!peek) return;
    row.addEventListener('mousemove', function(e){
      var r = row.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      peek.style.left = Math.min(r.width - 320, Math.max(20, x + 30)) + 'px';
      peek.style.top = (y - peek.offsetHeight * .5) + 'px';
    });
  });
})();

(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
    });
  },{threshold:0.16, rootMargin:'0px 0px -6% 0px'});
  document.querySelectorAll('[data-reveal]').forEach(function(el){ io.observe(el); });

  /* Header state */
  var bar = document.getElementById('topbar');

  /* Smooth parallax with lerp */
  var plx = [];
  document.querySelectorAll('[data-plx]').forEach(function(el){
    plx.push({el:el, speed:parseFloat(el.getAttribute('data-plx'))||0});
  });
  var drift = document.querySelector('[data-drift]');
  var slice = document.querySelector('.slice');
  var target = window.scrollY, current = target;

  function onScroll(){ target = window.scrollY; }
  window.addEventListener('scroll', onScroll, {passive:true});

  function frame(){
    current += (target - current) * 0.085;
    if(Math.abs(target-current) < 0.05) current = target;
    var vh = window.innerHeight;

    bar.classList.toggle('scrolled', target > 40);

    if(!reduced){
      plx.forEach(function(p){
        var r = p.el.getBoundingClientRect();
        var mid = r.top + r.height/2 - vh/2;
        p.el.style.transform = 'translate3d(0,' + (mid * p.speed).toFixed(2) + 'px,0)';
      });
      /* horizontal drift of collection cards */
      if(drift){
        var r = drift.getBoundingClientRect();
        var prog = Math.min(1, Math.max(0, 1 - (r.top - vh*0.1) / vh));
        drift.style.transform = 'translate3d(' + (-prog * Math.max(0, drift.scrollWidth - window.innerWidth + window.innerWidth*0.06)).toFixed(1) + 'px,0,0)';
      }
      /* two-greens seam shifts as you scroll through */
      if(slice){
        var sr = slice.getBoundingClientRect();
        var sp = Math.min(1, Math.max(0, (vh - sr.top) / (vh + sr.height)));
        slice.style.setProperty('--slice', (38 + sp*24).toFixed(2) + '%');
      }
      /* inner parallax for path/story/event imagery uses --plx-y on img wrappers */
      document.querySelectorAll('.split .half .ph img, .events .bg img, .story4 .im img, .hero.v2 .bg img').forEach(function(img){
        var rr = img.getBoundingClientRect();
        var m = (rr.top + rr.height/2 - vh/2) * 0.05;
        img.style.setProperty('--plx-y', m.toFixed(2) + 'px');
      });
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();

/* Shop filters, sorting, and AJAX-friendly product grid */
(function(){
  var shop = document.querySelector('[data-avant-shop]');
  if (!shop) return;
  var grid = shop.querySelector('[data-shop-grid]');
  var cards = Array.from(shop.querySelectorAll('[data-shop-card]'));
  var results = shop.querySelector('[data-shop-results]');
  var empty = shop.querySelector('[data-shop-empty]');
  var sort = shop.querySelector('[data-shop-sort]');
  var initialCollection = shop.dataset.initialCollection || 'all';
  var params = new URLSearchParams(location.search);
  if (params.has('style')) {
    params.delete('style');
    var cleanUrl = new URL(location.href);
    cleanUrl.searchParams.delete('style');
    history.replaceState(null, '', cleanUrl);
  }
  // Memorial arrangements belong on their dedicated page, including old links.
  if (initialCollection !== 'remembrance' && (params.get('collection') === 'remembrance' || params.get('occasion') === 'sympathy')) {
    var remembranceUrl = new URL(location.href);
    remembranceUrl.pathname = remembranceUrl.pathname.replace(/\/collections\/[^/]+\/?$/, '/collections/remembrance-sympathy');
    ['collection', 'occasion', 'style', 'size', 'tag'].forEach(function(key){ remembranceUrl.searchParams.delete(key); });
    location.replace(remembranceUrl.href);
    return;
  }
  var filters = { collection: initialCollection, occasion: 'all', size: 'all', tag: 'all', priceMin: 0, priceMax: Infinity };
  var visibleLimit = 6;
  var priceMin = shop.querySelector('[data-price-min]');
  var priceMax = shop.querySelector('[data-price-max]');
  var priceMinLabel = shop.querySelector('[data-price-min-label]');
  var priceMaxLabel = shop.querySelector('[data-price-max-label]');
  var priceTrack = shop.querySelector('[data-shop-price]');
  var priceGroup = shop.querySelector('.sh-price');
  var loadMore = shop.querySelector('[data-shop-load-more]');
  var filterDrawer = shop.querySelector('#shopFilters');
  var filterOpen = shop.querySelector('[data-mobile-filter-open]');
  var filterClose = shop.querySelector('[data-mobile-filter-close]');
  var filterApply = shop.querySelector('[data-mobile-filter-apply]');

  function setFilterDrawer(open){
    if (!filterDrawer || !filterOpen) return;
    filterDrawer.classList.toggle('is-open', open);
    filterOpen.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('shop-filter-open', open);
    if (open) {
      filterDrawer.setAttribute('role', 'dialog');
      filterDrawer.setAttribute('aria-modal', 'true');
      if (filterClose) filterClose.focus();
    } else {
      filterDrawer.removeAttribute('role');
      filterDrawer.removeAttribute('aria-modal');
      if (filterDrawer.contains(document.activeElement)) filterOpen.focus();
    }
  }
  if (filterOpen) filterOpen.addEventListener('click', function(){ setFilterDrawer(true); });
  if (filterClose) filterClose.addEventListener('click', function(){ setFilterDrawer(false); });
  if (filterApply) filterApply.addEventListener('click', function(){ setFilterDrawer(false); });
  if (filterDrawer) filterDrawer.addEventListener('click', function(event){ if (event.target === filterDrawer) setFilterDrawer(false); });
  document.addEventListener('keydown', function(event){
    if (event.key === 'Escape') setFilterDrawer(false);
    if (event.key === 'Tab' && filterDrawer && filterDrawer.classList.contains('is-open')) {
      var focusable = Array.from(filterDrawer.querySelectorAll('button, a[href], input, summary')).filter(function(el){return el.offsetParent !== null && !el.disabled;});
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  function matches(card, group, value){
    if (!value || value === 'all') return true;
    if (group === 'size' && card.dataset.size) return card.dataset.size === value;
    var tags = (card.dataset.tags || '').trim().split(/\s+/);
    var aliases = {love:['love','because-i-love-you'], 'miss-you':['miss-you','because-i-miss-you','sympathy'], pretty:['pretty','because-its-pretty','just-because'], 'boys-flowers':['boys-like-flowers-too','boys-flowers'], plants:['plants','plant','orchids'], small:['small','s','petite'], medium:['medium','m','standard'], large:['large','l','grand'], 'extra-large':['extra-large','xl']};
    if (group === 'collection') return (card.dataset.collection || '').split(' ').indexOf(value) !== -1;
    return (aliases[value] || [value]).some(function(alias){ return tags.indexOf(alias) !== -1 || (group === 'occasion' && card.dataset.title === alias); });
  }
  function isRemembrance(card){
    return (card.dataset.collection || '').trim().split(/\s+/).indexOf('remembrance') !== -1;
  }
  function render(){
    var remembrance = filters.collection === 'remembrance';
    if (priceGroup) priceGroup.hidden = remembrance;
    if (priceMin) priceMin.disabled = remembrance;
    if (priceMax) priceMax.disabled = remembrance;
    var orderedCards = Array.from(grid.querySelectorAll('[data-shop-card]'));
    var visible = orderedCards.filter(function(card){
      var price = Number(card.dataset.price);
      if (isRemembrance(card) && !remembrance) return false;
      return matches(card, 'collection', filters.collection) && matches(card, 'occasion', filters.occasion) && matches(card, 'size', filters.size) && matches(card, 'tag', filters.tag) && (remembrance || (price >= filters.priceMin && price <= filters.priceMax));
    });
    cards.forEach(function(card){
      var matchIndex = visible.indexOf(card);
      var show = matchIndex !== -1 && matchIndex < visibleLimit;
      var wasHidden = card.hidden;
      card.hidden = !show;
      card.setAttribute('aria-hidden', String(!show));
      if (show && matchIndex < 6) {
        card.classList.add('in');
      } else if (show && wasHidden) {
        card.classList.remove('in');
        window.setTimeout(function(){ card.classList.add('in'); }, (matchIndex - 6) * 90 + 30);
      } else if (!show) {
        card.classList.remove('in');
      }
    });
    if (results) results.textContent = visible.length + (visible.length === 1 ? ' arrangement' : ' arrangements');
    if (empty) empty.hidden = visible.length !== 0;
    if (loadMore) loadMore.hidden = visible.length <= visibleLimit;
  }
  function sortCards(value){
    var sorted = cards.slice().sort(function(a,b){
      if (value === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
      if (value === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
      if (value === 'newest') return Number(b.dataset.created) - Number(a.dataset.created);
      return Number(a.dataset.order) - Number(b.dataset.order);
    });
    sorted.forEach(function(card){ grid.appendChild(card); });
  }
  shop.addEventListener('click', function(event){
    var filter = event.target.closest('[data-shop-filter]');
    if (filter) {
      // A dedicated collection only contains its own products. Follow the
      // collection link to the complete catalog before switching collections.
      if (initialCollection !== 'all' && filter.dataset.shopFilter === 'collection') return;
      event.preventDefault();
      var group = filter.dataset.shopFilter;
      var value = filter.dataset.filterValue;
      filters[group] = filters[group] === value && group !== 'collection' ? 'all' : value;
      if (group === 'occasion' && value === 'all') filters.tag = 'all';
      var filterUrl = new URL(location.href);
      if (filters[group] === 'all') filterUrl.searchParams.delete(group); else filterUrl.searchParams.set(group, filters[group]);
      if (filters.tag === 'all') filterUrl.searchParams.delete('tag');
      history.replaceState(null, '', filterUrl);
      visibleLimit = 6;
      shop.querySelectorAll('[data-shop-filter="' + group + '"]').forEach(function(item){
        var active = filters[group] === item.dataset.filterValue;
        item.classList.toggle('on', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });
      render();
    }
    if (event.target.closest('[data-shop-reset]')) {
      filters = { collection: initialCollection, occasion: 'all', size: 'all', tag: 'all', priceMin: 0, priceMax: Infinity };
      var resetUrl = new URL(location.href);
      ['collection', 'occasion', 'size', 'style', 'tag'].forEach(function(key){resetUrl.searchParams.delete(key);});
      history.replaceState(null, '', resetUrl);
      visibleLimit = 6;
      shop.querySelectorAll('[data-shop-filter]').forEach(function(item){
        var active = item.dataset.filterValue === filters[item.dataset.shopFilter];
        item.classList.toggle('on', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (sort) sort.value = 'featured';
      if (priceMin && priceMax) { priceMin.value = priceMin.min; priceMax.value = priceMax.max; updatePrice(); }
      sortCards('featured');
      render();
    }
  });
  if (sort) sort.addEventListener('change', function(){ visibleLimit = 6; sortCards(sort.value); render(); });
  function updatePrice(changed){
    var min = Number(priceMin.value), max = Number(priceMax.value);
    if (min > max) {
      if (changed === priceMin) max = min; else min = max;
      priceMin.value = String(min); priceMax.value = String(max);
    }
    visibleLimit = 6;
    filters.priceMin = min; filters.priceMax = max;
    priceMinLabel.textContent = '$' + min; priceMaxLabel.textContent = '$' + max;
    if (priceTrack) {
      var domainMin = Number(priceMin.min), domainMax = Number(priceMin.max);
      var minPos = ((min - domainMin) / (domainMax - domainMin)) * 100;
      var maxPos = ((max - domainMin) / (domainMax - domainMin)) * 100;
      priceTrack.style.setProperty('--price-min-pos', minPos.toFixed(2) + '%');
      priceTrack.style.setProperty('--price-max-pos', maxPos.toFixed(2) + '%');
    }
    render();
  }
  if (priceMin && priceMax) {
    var domainMax = Math.max(5, Math.ceil(Math.max.apply(null, cards.filter(function(card){return !isRemembrance(card);}).map(function(card){return Number(card.dataset.price);}).concat([0])) / 5) * 5);
    priceMin.min = priceMax.min = '0'; priceMin.max = priceMax.max = String(domainMax);
    priceMin.value = '0'; priceMax.value = String(domainMax); updatePrice();
    priceMin.addEventListener('input', function(){ updatePrice(priceMin); });
    priceMax.addEventListener('input', function(){ updatePrice(priceMax); });
  }
  if (loadMore) {
    var loadObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting && !loadMore.hidden) {
          visibleLimit += 3;
          render();
        }
      });
    }, { threshold:.1, rootMargin:'0px 0px 100px 0px' });
    loadObserver.observe(loadMore);
  }
  ['collection','occasion','size','tag'].forEach(function(group){ if(params.has(group)) filters[group] = params.get(group); });
  // Keep previously shared Remembrance links working.
  if (filters.occasion === 'sympathy') {
    filters.collection = 'remembrance';
    filters.occasion = 'all';
  }
  shop.querySelectorAll('[data-shop-filter]').forEach(function(item){var active=filters[item.dataset.shopFilter]===item.dataset.filterValue;item.classList.toggle('on',active);item.setAttribute('aria-current',String(active));});
  render();
})();
